import { produce } from "immer";
import _ from "lodash";
import { mergeWithArrays } from "src/util/functions";
import { kDefaultUser } from "./defaultData";
import { tAdminUserAction, tAdminUserState, tSetAdminUserSettings, tUpdateAdminUserSettings } from "./types";

const handleSetAdminUser = (action: tSetAdminUserSettings): tAdminUserState => {
  return Object.assign(_.cloneDeep(kDefaultUser), action.user);
};

const handleUpdate = (state: tAdminUserState, action: tUpdateAdminUserSettings): tAdminUserState => {
  return mergeWithArrays<tAdminUserState>(state, "MERGE", action.userPart);
};

// Inspiration from: https://adostes.medium.com/simplify-redux-reducers-with-immer-9a3638229d45
export const AdminUserReducer = produce(
  (draft: tAdminUserState = kDefaultUser, action: tAdminUserAction): tAdminUserState => {
    switch (action.type) {
      case "ADMIN_SET_USER":
        return handleSetAdminUser(action);
      case "ADMIN_UPDATE_USER":
        return handleUpdate(draft, action);
      default:
        return draft;
    }
  },
);
